angular.module('rjmNg.common.api').factory 'Tokens', [
  "$q"
  "$resource"
  "serviceUrl"
  (
    $q
    $resource
    serviceUrl
  ) ->
    tokensBaseUrl = '/tokens'

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      invalidate: angular.extend {}, defaultParams,
        method: 'POST'
        url: serviceUrl(tokensBaseUrl + "/:id/invalidate")
        id: '@id'
      get: angular.extend {}, defaultParams,
        method: 'GET'
        url: serviceUrl(tokensBaseUrl + "/authenticate")

    tokensResource = $resource(tokensBaseUrl, {}, actions)

    Tokens =
      invalidate: (tokenId) ->
        invalidateDeferred = $q.defer()
        tokensResource.invalidate({id: tokenId}, {}).$promise.then((success) ->
          invalidateDeferred.resolve({success: true})
        , (error) ->
          invalidateDeferred.reject()
        )
        invalidateDeferred.promise

      get: () ->
        tokensResource.get().$promise

    Tokens
]
